import { Plane, Train, Bus, Car, Box, Doc } from '../Icons';

const items = [
  { Icon: Plane, label: 'Flights' },
  { Icon: Train, label: 'Trains' },
  { Icon: Bus, label: 'Buses' },
  { Icon: Car, label: 'Road trips' },
  { Icon: Box, label: 'Parcels & luggage' },
  { Icon: Doc, label: 'Documents' },
];

export default function Modes() {
  return (
    <section className="modes" aria-label="Supported travel modes and items">
      <div className="container">
        <p className="modes__title">Every way people travel, and everything they can carry</p>
        <div className="modes__row">
          {items.map(({ Icon, label }) => (
            <div className="modes__item" key={label}>
              <Icon width={22} height={22} /> {label}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
